import request from '@/utils/request'

// 分页查询工厂实景信息列表
export function pageFactoryLiveScene(query) {
  return request({
    url: '/website/factoryLiveScene/page',
    method: 'get',
    params: query
  })
}